<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算行</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main_list">
            <div class="flex">
                <div class="main_header_btns">
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="this.postList.tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_item_line"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <span> {{ scope.row[item.prop] }} </span>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" align="center" fixed="right" width="80">
                    <template slot-scope="scope" style="height: 100%" v-if="scope.row.status !== 1">
                        <el-tooltip class="item" effect="dark" content="调零" placement="top-start">
                            <i class="el-icon-s-help" @click="adjust(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'budgetLineComponent',
    data() {
        return {
            draggable: {
                data_name: 'budget_item_line'
            },
            tableData: [],
            colData: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
        });
    },
    methods: {
        //调零
        adjust(row) {
            if (row.status == 2) {
                if (this.postList.list.budget_executable > 0) {
                    this.$router.push({
                        path: '/budgetSourceEdit',
                        query: {
                            type: 4,
                            id: row.budget_item_rid,
                            name: this.postList.list.name,
                            editType: 2,
                            remark: '预算调零',
                            amount: -this.postList.list.budget_executable,
                            period: row.period
                        }
                    });
                } else {
                    this.$message({
                        message: '暂无可调零预算',
                        type: 'warning'
                    });
                }
            } else {
                if (row.budget > 0) {
                    this.$router.push({
                        path: '/budgetSourceEdit',
                        query: {
                            type: 4,
                            id: row.budget_item_rid,
                            name: this.postList.list.name,
                            editType: 2,
                            remark: '预算调零',
                            amount: -row.budget,
                            period: row.period
                        }
                    });
                } else {
                    this.$message({
                        message: '暂无可调零预算',
                        type: 'warning'
                    });
                }
            }
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
           onReSize('budget_item_line', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_item_line;
        }
    }
};
</script>
<style lang="scss" scoped>
// 让“暂无数据”文本居中显示
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>